import React, { useState, useRef, useEffect } from 'react';
import './Dropdown.css';

export interface DropdownItem { key: string; label: string; icon?: React.ReactNode; danger?: boolean; divider?: boolean; disabled?: boolean; }

export interface DropdownProps {
  trigger: React.ReactNode;
  items: DropdownItem[];
  onSelect: (key: string) => void;
  align?: 'left' | 'right';
  className?: string;
}

export function Dropdown({ trigger, items, onSelect, align = 'left', className = '' }: DropdownProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} className={`ui-dropdown ${className}`}>
      <div onClick={() => setOpen(!open)} className="ui-dropdown-trigger">{trigger}</div>
      {open && (
        <div className={`ui-dropdown-menu ui-dropdown-${align}`}>
          {items.map(item =>
            item.divider ? <div key={item.key} className="ui-dropdown-divider" /> : (
              <button key={item.key} className={`ui-dropdown-item ${item.danger ? 'ui-dropdown-danger' : ''}`}
                disabled={item.disabled} onClick={() => { onSelect(item.key); setOpen(false); }}>
                {item.icon && <span className="ui-dropdown-icon">{item.icon}</span>}
                {item.label}
              </button>
            )
          )}
        </div>
      )}
    </div>
  );
}
